import Script from 'next/script';
import * as React from 'react';

const ScriptTags = () => {
  React.useEffect(() => {
    // Only load Boost chat in production to avoid local/CORS errors
    if (process.env.NODE_ENV !== 'production') return;

    // Check if script already exists
    const existingScript = document.querySelector('script[src*="chatPanel.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://syn.boost.ai/chatPanel/chatPanel.js';
      script.async = true;

      script.onerror = () => {
        // Avoid throwing on network errors (keeps local/dev quiet)
        // eslint-disable-next-line no-console
        console.warn('Boost chat failed to load');
      };

      script.onload = () => {
        // @ts-expect-error window.boostInit comes from the loaded script
        const { chatPanel } = window.boostInit('syn', {});

        chatPanel.addEventListener(
          'triggerAction',
          (ev: { detail: { actionId: string | number; durationBeforeTimeout: number | undefined } }) => {
            setTimeout(() => {
              chatPanel.triggerAction(ev.detail.actionId);
            }, ev.detail.durationBeforeTimeout);
          }
        );
      };
      document.body.appendChild(script);

      return () => {
        // Cleanup on unmount
        document.body.removeChild(script);
      };
    }
    return () => {};
  }, []);

  return (
    <>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NLZRCT');`,
        }}
      />
      <Script
        id="hotjar-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:771167,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`,
        }}
      />
    </>
  );
};
export default ScriptTags;
